import { Component, Host, h, Prop, Watch, State, Event, type EventEmitter, Element } from '@stencil/core';

export interface FiltersCollapseData {
  clearSelected: boolean
}

@Component({
  tag: 'filters-header-menu',
  styleUrl: 'filters-header-menu.scss',
  shadow: true,
})
export class FiltersHeaderMenu {
  @Element() el!: HTMLElement;
  @Prop({attribute: 'collapsed'}) readonly collapsedProp: boolean = false;
  @Watch('collapsedProp')
  onCollapsedChange(newValue: boolean) {
      this.collapsed = newValue;
  }

  @Prop({attribute: 'show-chips'}) readonly showChipsProp: boolean = false;
  @Watch('showChipsProp')
  onShowChipsChange(newValue: boolean) {
      this.showChips = newValue;
  }

  @State() collapsed = false;
  @State() showChips = false;

  @Event({bubbles: false}) clickFiltersNavbar: EventEmitter<FiltersCollapseData>;

  private openClickHostDelegator(event: Event, clearSelected = true): void {
      if(event.target === this.el && !this.showChips) {
        this.clickFiltersNavbar.emit({clearSelected});
      }
  }

  componentWillLoad() {
      this.collapsed = this.collapsedProp;
      this.showChips = this.showChipsProp;
  }

  render() {
      return (
        <Host
          class={{
            'hm-no-chips': !this.showChips,
            'more-height': this.collapsed && !this.showChips
          }}
          onClick={e => this.openClickHostDelegator(e, this.collapsed)}
        >
          <div class={'hm-left-button'}>
            <slot name={'hm-left-button'}></slot>
          </div>
          {this.showChips ? <div class={'hm-right-chips'}>
            <slot name={'hm-right-chips'}></slot>
          </div> : ''}
          {!this.showChips ? <button
            type="button"
            class={{
              'hm-button': true,
              'margin-r-10': this.collapsed
            }}
          >
            {
              this.collapsed
                ? <se-icon
                  size="small"
                >
                  action_close
                </se-icon>
                : <span class='cta-color'>
                  <se-icon
                    size="micro"
                  >
                    arrow2_right
                  </se-icon>
                </span>
            }
          </button> : ''}
        </Host>
      );
  }
}
